import RegistrationForm from "../blocks/RegistrationForm/RegistrationForm";
import { LoginForm } from "../blocks/LoginForm/LoginForm";
import Footer from "../blocks/Footer/Footer";
import Navbar from "../blocks/Navbar/Navbar";
import { Speakers } from "../blocks/Speakers/Speakers";
import Contacts from "../blocks/Contacts/Contacts";
import Hero, { HeroCustom } from "../blocks/Hero/Hero";
import { Agenda } from "../blocks/Agenda/Agenda";
import { Episodes } from "../blocks/Episodes/Episodes";
import Row from "../ui/Row/Row";
import { OpenLoginModalButton } from "../ui/Buttons/OpenLoginModalButton/OpenLoginModalButton";
import { PublicQuestion } from "../blocks/PublicQuestion/PublicQuestion";
import Info from "../blocks/Info/Info";
import { Related } from "../blocks/Related/Related";
import Slider from "../blocks/Slider/Slider";
import HomepageHeader from "../blocks/HomepageHeader/HomepageHeader";
import Takeaways from "../blocks/Takeaways/Takeaways";
var UI = {
    // blocks
    RegistrationForm: RegistrationForm,
    LoginForm: LoginForm,
    Footer: Footer,
    Navbar: Navbar,
    Speakers: Speakers,
    Contacts: Contacts,
    Hero: Hero,
    Agenda: Agenda,
    Episodes: Episodes,
    PublicQuestion: PublicQuestion,
    Info: Info,
    Related: Related,
    Slider: Slider,
    HomepageHeader: HomepageHeader,
    Takeaways: Takeaways,
    HeroCustom: HeroCustom,
    //ui
    Row: Row,
    LoginButton: OpenLoginModalButton
};
export default UI;
